import { useCallback, useMemo, useState } from 'react';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Box } from 'foundations-components/transitional/components/Box';
import { Text } from 'foundations-components/components/Text';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { getTransferrableProps } from '../../../utils/getTransferrableProps';
import { useProperty } from '../../../v2/hooks/useProperty';
import { usePropertyValue } from '../../../v2/hooks/usePropertyValue';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { jsx as _jsx } from "react/jsx-runtime";
export const TextAreaPopover = props => {
  const {
    inputRef,
    onChange,
    popoverProps,
    placeholder
  } = props;
  const [showPopover, setShowPopover] = useState(true);
  const property = useProperty();
  const value = usePropertyValue();
  const displayedValue = value || placeholder;
  const popoverContent = useMemo(() => {
    const handleChange = event => {
      return onChange(event);
    };
    return /*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "600",
      children: /*#__PURE__*/_jsx(TextArea, Object.assign({}, getTransferrableProps(props), {
        value: value === null ? '' : value,
        inputRef: inputRef,
        onChange: handleChange,
        styled: true,
        rows: 6
      }))
    });
  }, [props, value, inputRef, onChange]);
  const handleOpenChange = useCallback(evt => {
    setShowPopover(evt.target.value);
  }, []);
  const handleClick = useCallback(() => {
    setShowPopover(prev => !prev);
  }, []);
  return /*#__PURE__*/_jsx(Popover, Object.assign({
    inlineSize: "400px",
    placement: "right"
  }, popoverProps, {
    open: showPopover,
    content: {
      body: popoverContent,
      header: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: property.label
      })
    },
    onOpenChange: handleOpenChange,
    showCloseButton: true,
    "data-test-id": "property-input-text-area-popover",
    children: /*#__PURE__*/_jsx(Clickable, {
      onClick: handleClick,
      "data-test-id": "property-input-text-area-preview",
      alignItems: "center",
      blockSize: "100%",
      inlineSize: "100%",
      justifyContent: "center",
      display: "flex",
      children: /*#__PURE__*/_jsx(TruncateString, {
        tooltip: !showPopover,
        children: displayedValue
      })
    })
  }));
};
export default TextAreaPopover;